import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useRedux';
import { selectPreferredDashboardRoute } from '../../store/auth/authSelectors';
import { Button } from './Button';

interface FeatureAccessDeniedProps {
  title?: string;
  description?: string;
}

export const FeatureAccessDenied: React.FC<FeatureAccessDeniedProps> = ({
  title = 'Access restricted',
  description = 'Your account does not have permission to use this area. Contact an administrator if you need access.',
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const preferredDashboardRoute = useAppSelector(selectPreferredDashboardRoute);
  const canRedirectToPreferredRoute = Boolean(
    preferredDashboardRoute && preferredDashboardRoute !== location.pathname,
  );

  return (
    <div className="flex min-h-[280px] items-center justify-center">
      <div className="app-bg w-full max-w-2xl rounded-2xl border border-emerald-100 px-6 py-8 text-center shadow-sm">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white text-emerald-600 shadow-sm">
          <ShieldAlert size={24} />
        </div>
        <h2 className="mt-4 text-xl font-semibold text-black">{title}</h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-black/70">
          {description}
        </p>

        {canRedirectToPreferredRoute ? (
          <div className="mt-5 flex justify-center">
            <Button
              onClick={() => navigate(preferredDashboardRoute || '/dashboard')}
              className="min-w-[200px]"
            >
              Go To Allowed Page
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
